import React, { useEffect } from "react"
import { FasesHeaderProps } from "./fases-header-props"
import { Box, Button, Divider, IconButton, Typography } from "@material-ui/core"
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import { useStyles } from "./fases-header-styles";
import classNames from "classnames";
import { useSacolaAbertaStore } from "services/store/sacola-aberta";

export const FasesHeader = ({
    titulo,
    icon: Icon,
    voltar,
    isSacola = false,
    handleLimparSacola,
}: FasesHeaderProps) => {

    const classes = useStyles()
    const sacolaAberta = useSacolaAbertaStore((state) => state.sacolaAberta)
    // Intercept browser back when sacola is aberta and execute the FasesHeader voltar behavior
    useEffect(() => {
        const handlePopState = (event: PopStateEvent) => {
            if (sacolaAberta) {
                voltar()
            }
        };
        window.addEventListener('popstate', handlePopState);
        return () => {
            window.removeEventListener('popstate', handlePopState);
        };
    }, [sacolaAberta, voltar])

    return (
        <Box className={classes.header}>
            <Box className={classes.container}>
                <IconButton
                    onClick={() => voltar()}
                    className={classes.iconButton}
                >
                    <ArrowBackIosIcon className={classNames(classes.iconVoltar, isSacola && classes.iconVoltarSacola)} />
                </IconButton>
                <Box display="flex" alignItems="center">
                    <Box className={classes.content}>
                        {Icon && <Icon tipo="INPUT" class={classes.icon} />}
                    </Box>
                    <Typography
                        className={classes.label}
                    >
                        {typeof titulo === 'string' ? titulo.toUpperCase() : titulo}
                    </Typography>
                </Box>
                {isSacola && (
                    <Button
                        variant="text"
                        color="primary"
                        onClick={() => handleLimparSacola?.()}
                        className={classes.limparSacola}
                    >
                        Limpar
                    </Button>
                )}
            </Box>
            <Divider className={classes.divider} />
        </Box>
    )
}